import {Injectable} from '@angular/core';
import {GeneralService} from './general.service';
import {map} from 'rxjs/operators';

import {catchError, forkJoin, Observable, of} from 'rxjs';
import {NICEAgent} from '../models/NICE_Agent.model';
import {NICEUserSkill} from '../models/NICE_UserSkill.model';
import {NICEUserStates} from '../models/NICE_UserStates.model';
import {NICESecurityProfile} from '../models/NICE_SecurityProfile.model';
import {NICEUserStateHistory} from '../models/NICE_UserStateHistory';
import {NICEUserPerformance} from '../models/NICE_UserPerformance';
import {NICEClientData} from '../models/NICE_ClientData.model';
import {NICEApiHelper} from '../models/NICE_ApiHelper.model';
import {NICEBusinessUnit} from '../models/NICE_BusinessUnit.model';
import {NICEUserPermissions} from "../models/NICE_UserPermissions";


@Injectable({
    providedIn: 'root'
})
export class IcDataUserService {
    private url: string;
    private apiHelper: NICEApiHelper = new NICEApiHelper();
    private dataJSON: string;
    private modData: any[];
    private addData: any[];
    private delData: any[];
    private userFilterValue = '';

    constructor(
        public genHttp: GeneralService,
    ) {

    }
    public getBUData(bu: number):  Observable<any> {
        return this.genHttp.icGet('baseURL/services/' + this.apiHelper.apiVersion + '/business-unit')
            .pipe(map((response: any) => Object.assign(new NICEBusinessUnit(), response.businessUnits[0])));
    }

    public getAgent(id: string): Observable<{agent: NICEAgent, resultMessage?: string}> {
        return this.genHttp.icGet('baseURL/services/' + this.apiHelper.apiVersion + '/agents/' + id)
            .pipe(
                map((response: any) =>
                    ({resultMessage:'', agent: new NICEAgent(response.agents[0])})),
                catchError((err) => {
                    if (err.status === 409 && err.error?.error_description === 'InvalidPermissions') {
                        return this.getFallbackAgent(id);
                    }
                    return of({resultMessage:'APIFailure:' +err.status + ' ' + err.statusText, agent: null}
                    )
                })
            );
    }

    public getFallbackAgent(id: string): Observable<{agent: NICEAgent, resultMessage?: string}> {
        return this.genHttp.icGet('baseURL/services/v16.0/agents/' + id)
            .pipe(
                map((response: any) =>
                    ({resultMessage:'FallbackAgentAPI', agent: new NICEAgent(response.agents[0])})),
                catchError((err) =>
                    of({resultMessage:'APIFailure:' +err.status + ' ' + err.statusText, agent: null})
                )
            );
    }

    public endSession(id: string): Promise<any> {
        return new Promise((resolve, reject) => {
            this.genHttp.icDelete('baseURL/services/' + this.apiHelper.apiVersion + '/agent-sessions?sessionID=' + id +
                '&forceLogoff=true&endContacts=true&ignorePersonalQueue=true', '')
                .pipe(map((response: any) => response))
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    public joinSession(id: string): Promise<any> {
        return new Promise((resolve, reject) => {
            this.genHttp.icPost('baseURL/services/' + this.apiHelper.apiVersion + '/agent-sessions/join?asagentId=' + id, '')
                .pipe(map((response: any) => response))
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    public getAgentSkill(id: string, parms?: string): Promise<NICEUserSkill[]> {
        if (!parms) {
            parms = '';
        }
        return new Promise((resolve, reject) => {
            this.genHttp.icGet('baseURL/services/' + this.apiHelper.apiVersion + '/agents/' + id + '/skills' + parms)
                .pipe(map((response: any) => {
                    if (response === null) {
                        return [];
                    }
                    return response.agentSkillAssignments.map(data => new NICEUserSkill(data));
                }))
                .subscribe((response: NICEUserSkill[]) => {
                    resolve(response);
                }, reject);
        });
    }

    public getUserStates(id: string, parms?: string): Promise<NICEUserStates[]> {
        if (!parms) {
            parms = '';
        }
        return new Promise((resolve, reject) => {
            this.genHttp.icGet('baseURL/services/' + this.apiHelper.apiVersion + '/agents/' + id + '/states' + parms)
                .pipe(map((response: any) => {
                    if (response === null) {
                        return [];
                    }
                    return response.agentStates.map(data => new NICEUserStates(data));
                }))
                .subscribe((response: NICEUserStates[]) => {
                    resolve(response);
                }, reject);
        });
    }

    public getSecurityProfiles(para?: string): Observable<NICESecurityProfile[]> {
        if (!para) {
            para = '';
        }
            return this.genHttp.icGet('baseURL/services/' + this.apiHelper.apiVersion + '/security-profiles' + para)
                .pipe(map((response: any) =>
                    //                   console.log(response);
                     response.securityProfiles.map(data => new NICESecurityProfile(data))
                ))
    }

    public getStateHistory(id: string, para?: string): Promise<any[]> {
        if (!para) {
            para = '?startDate=2020-05-27T00:00:00&endDate=2020-05-28T00:00:00&orderBy=startDate desc';
        } else {
            para = para + '&orderBy=startDate desc';
        }
        return new Promise((resolve, reject) => {
            this.genHttp.icGet('baseURL/services/' + this.apiHelper.apiVersion + '/agents/' + id + '/state-history' + para)
                .pipe(map((response: any) =>
//                    console.log(response);
                     response.agentStateHistory.map(data => new NICEUserStateHistory(data))
                ))
                .subscribe((response: NICEUserStateHistory[]) => {
                    resolve(response);
                }, reject);
        });
    }

    public getUserPerformance(id: string, para?: string): Promise<any[]> {
        if (!para) {
            para = '?startDate=2020-05-27T00:00:00&endDate=2020-05-28T00:00:00';
        }
        return new Promise((resolve, reject) => {
            this.genHttp.icGet('baseURL/services/' + this.apiHelper.apiVersion + '/agents/' + id + '/performance' + para)
                .pipe(map((response: any) =>
//                    console.log(response);
                     response.agentPerformance.map(data => new NICEUserPerformance(data))
                    // return response;
                ))
                //                .subscribe((response: NICEUserStateHistory[]) => {
                .subscribe((response: NICEUserPerformance[]) => {
                    resolve(response);
                }, reject);
        });
    }

    public updateUserById(agentId:string, data: NICEAgent): Promise<any> {
        this.url = 'baseURL/services/' + this.apiHelper.apiVersion + '/agents/' + agentId;
        const dataJSON = '{"agent":' + JSON.stringify(data) + '}';
        return new Promise((resolve, reject) => {
            this.genHttp.icPut(this.url, dataJSON).subscribe((response: any) => {
                resolve(response);
            }, reject);
        });
    }

    public updateUser(data: NICEAgent): Promise<any> {
        // this.url = 'baseURL/services/' + this.auth.apiVersion + '/points-of-contact/' + data.ContactCode;
        this.url = 'baseURL/services/' + this.apiHelper.apiVersion + '/agents/' + data.agentId;
        const agentUpdateData = {
            city: data.city,
            country: data.country,
            custom1: data.custom1,
            custom2: data.custom2,
            custom3: data.custom3,
            custom4: data.custom4,
            custom5: data.custom5,
            emailAddress: data.emailAddress,
            firstName: data.firstName,
            isActive: data.isActive,
            lastName: data.lastName,
            notes: data.notes,
            profileId: data.profileId,
            state: data.state,
            teamId: data.teamId.toString(),
            telephone1: data.telephone1,
            telephone2: data.telephone2,
            userName: data.userName,
            internalId: data.internalId,
        };
        // apiKey
        // atHome
        // chatRefusalTimeout
        // chatThreshold
        // city
        // contactAutoFocus
        // country
        // crmUserName
        // defaultDialingPattern
        // emailAddress
        // emailRefusalTimeout
        // emailThreshold
        // employmentType
        // federatedId
        // hireDate
        // hourlyCost
        // internalId
        // isOpenIdProfileComplete
        // isWhatIfAgent
        // issuer
        // maxConcurrentChats
        // maxEmailAutoParkingLimit
        // maxPreview
        // notes
        // ntLoginName
        // phoneRefusalTimeout
        // recordingNumbers
        // referral
        // rehireStatus
        // requestContact
        // scheduleNotification
        // sendEmailNotifications
        // sipUser
        // smsRefusalTimeout
        // subject
        // systemDomain
        // systemUser
        // teamId
        // teamUuid
        // telephone1
        // telephone2
        // terminationDate
        // useAgentTimeZone
        // useTeamChatThreshold
        // useTeamContactAutoFocus
        // useTeamDeliveryModeSettings
        // useTeamEmailAutoParkingLimit
        // useTeamEmailThreshold
        // useTeamMaxConcurrentChats
        // useTeamRequestContact
        // useTeamWorkItemThreshold
        // userId
        // userName
        // userType
        // voiceThreshold
        // voicemailRefusalTimeout
        // workItemRefusalTimeout
        // workItemThreshold

        if (agentUpdateData.city === '') {
            delete agentUpdateData.city;
        }
        if (agentUpdateData.state === '') {
            delete agentUpdateData.state;
        }
        if (agentUpdateData.country === '') {
            delete agentUpdateData.country;
        }
        const dataJSON = '{"agent":' + JSON.stringify(agentUpdateData) + '}';
        return new Promise((resolve, reject) => {
            this.genHttp.icPut(this.url, dataJSON).subscribe((response: any) => {
                resolve(response);
            }, reject);
        });
    }

    public changeAgentState(session: string, data: string): Promise<any> {
        this.url = 'baseURL/services/' + this.apiHelper.apiVersion + '/agent-sessions/' + session + '/state';
        return new Promise((resolve, reject) => {
            this.genHttp.icPost(this.url, data).subscribe((response: any) => {
                // console.log('resp', response);
                resolve(response);
            }, reject);
        });
    }

    public updateUserSkills(agentId: string, data: any): Promise<any> {
        this.url = 'baseURL/services/' + this.apiHelper.apiVersion + '/agents/' + agentId + '/skills';
        this.dataJSON = '{"skills":' + JSON.stringify(data) + '}';
//        console.log(this.url, this.dataJSON);
        return new Promise((resolve, reject) => {
            if (data.length !== 0) {
                this.genHttp.icPut(this.url, this.dataJSON).subscribe((response: any) => {
//                    console.log('resp', response);
                    resolve(response);
                }, reject);
            } else {
                resolve(null);
            }
        });
    }

    public deleteUserSkills(agentId: string, data: any): Promise<any> {
        this.url = 'baseURL/services/' + this.apiHelper.apiVersion + '/agents/' + agentId + '/skills';
        this.dataJSON = '{"skills":' + JSON.stringify(data) + '}';
//        console.log(this.url, this.dataJSON);
        return new Promise((resolve, reject) => {
            if (data.length !== 0) {
                this.genHttp.icDelete(this.url, this.dataJSON).subscribe((response: any) => {
//                    console.log('resp', response);
                    resolve(response);
                }, (err) => {
                    console.log(err);
                });
            } else {
                resolve(null);
            }
        });
    }

    public logoffUser(agentId: string): Promise<any> {
        this.url = 'baseURL/services/' + this.apiHelper.apiVersion + '/agents/' + agentId + '/logout';
        return new Promise((resolve, reject) => {
            this.genHttp.icPost(this.url, '').subscribe((response: any) => {
//                    console.log('resp', response);
                resolve(response);
            }, reject);
        });
    }

    public addUserSkills(agentId: string, data: any): Promise<any> {
        this.url = 'baseURL/services/' + this.apiHelper.apiVersion + '/agents/' + agentId + '/skills';
        this.dataJSON = '{"skills":' + JSON.stringify(data) + '}';
//        console.log(this.url, this.dataJSON);
        return new Promise((resolve, reject) => {
            console.log(data);
            if (data.length !== 0) {
                this.genHttp.icPost(this.url, this.dataJSON).subscribe((response: any) => {
//                    console.log('resp', response);
                    resolve(response);
                }, (err) => {
                    console.log(err);
                });
            } else {
                resolve(null);
            }
        });
    }


    public updateUsersWithSkill(originalData: NICEUserSkill[], newUserSkill: NICEUserSkill[], user2Assign: string): Promise<any> {
        // get current agent/skill association
//            console.log('orig', OriginalData);
//            console.log('new', newUserSkill);
            this.modData = [];
            this.addData = [];
            this.delData = [];
            for (const orig of originalData) {
                let found = false;
                for (const newA of newUserSkill) {
                    if (orig.skillId === newA.skillId) {
                        found = true;
                        this.modData.push({
                            skillId: newA.skillId.toString(),
                            proficiency: newA.agentProficiencyValue,
                            isActive: newA.isActive
                        });
                        break;
                    }
                }
                if (!found) {
                    this.delData.push({skillId: orig.skillId.toString()});
                }
            }
            for (const newA of newUserSkill) {
                let found = false;
                for (const orig of originalData) {
                    if (orig.skillId === newA.skillId) {
                        found = true;
                        break;
                    }
                }
                if (!found) {
                    this.addData.push({
                        skillId: newA.skillId.toString(),
                        proficiency: newA.agentProficiencyValue,
                        isActive: newA.isActive
                    });
                }
            }
            return new Promise((resolve, reject) => {
            const source = forkJoin({
                del: this.deleteUserSkills(user2Assign, this.delData),
                add: this.addUserSkills(user2Assign, this.addData),
                mod: this.updateUserSkills(user2Assign, this.modData)
            });
            source.subscribe((res) => {
                resolve(res);
            }, (err) => {
                console.log(err);
            });
        });
    }

    public inviteUser(businessUnit: number, username: string, emailAddress: string): Promise<any> {
        return new Promise((resolve, reject) => {
            const URL = 'licenseURL/registeredBusinessUnit/' + businessUnit + '/invite/' + username + '/email/' + emailAddress + '/';
            this.genHttp.icGet(URL)
                .pipe(map((response: any) => response))
                .subscribe((response: any) => {
                    resolve(response);
                }, (err) => {
                    console.log(err);
                });
        });
    }

    public getClientData(id: string ): Promise<NICEClientData> {
        return new Promise((resolve, reject) => {
            this.genHttp.icGet('baseURL/services/' + this.apiHelper.apiVersion + '/agents/client-data?agentId=' + id)
                .pipe(map((response: any) => {
                    if (Object.prototype.hasOwnProperty.call(response, 'Data')) {
                        const dataResult = JSON.parse(response.Data);
                        return new NICEClientData(dataResult);
                    }
                    return new NICEClientData();
                }))
                .subscribe((response: NICEClientData) => {
                    resolve(response);
                }, reject);
        });
    }

    public updateClientData(clientData: NICEClientData, id: number): Promise<any> {
        return new Promise((resolve, reject) => {
            const payLoad = {agentId: id, dataSet: JSON.stringify(clientData)};
            this.genHttp.icPut('baseURL/services/' + this.apiHelper.apiVersion + '/agents/client-data?agentId=' + id, JSON.stringify(payLoad))
                .subscribe((response: NICEClientData) => {
                    resolve(response);
                }, reject);
        });
    }

    public getUserFilter(): string {
        return this.userFilterValue;
    }

    public putUserFiler(filter: string): void {
        this.userFilterValue = filter;
    }

    getPermissions(icAgentId: any):Observable<NICEUserPermissions> {
            return this.genHttp.icGet('baseURL/services/' + this.apiHelper.apiVersion + '/permissions?agentId='+icAgentId)
                .pipe(map((response: any) => new NICEUserPermissions(response.permissions)));
    }
}
